import { ComponentProps } from '@stitches/react'
import { useMemo } from 'react'
import { CircleRoot } from './Circle.styles'

type CircleOwnProps = ComponentProps<typeof CircleRoot>
type CircleProps = CircleOwnProps & {
  size?: number
}

export const Circle = ({ size, ...rest }: CircleProps) => {
  const style = useMemo(() => {
    return size ? { size: `$${size}` } : {}
  }, [size])

  return <CircleRoot css={style} {...rest} />
}
